import { Box, Text, theme } from '@gassan-ui'
import React, { FC } from 'react'

type Props = {
  title: string
  label: string
}

const Notice: FC<Props> = ({ title, label }) => {
  return (
    <Box
      mt={{
        _: '1.5rem',
        small: '2.5rem'
      }}
      mb={{
        _: '1.5rem',
        large: '2.25rem'
      }}
      p={['1rem', '1.5rem']}
      border={`1px solid ${theme.colors.shades[500]}`}
    >
      <Text variant="regularBold" color="shades.500" mb="0.25rem">
        {title}
      </Text>
      <Text color="shades.500" mb="0">
        {label}
      </Text>
    </Box>
  )
}

export default Notice
